@if (init.loading()) {
<div class="app-splash-spinner">
  <mat-spinner color="primary"></mat-spinner>
</div>
} @else {
<router-outlet />
}
